import React, { useState } from 'react';

import RequestService from "../../services/request.service";

import AuthService from '../../features/auth/auth.service'

import {Button, Modal } from 'react-bootstrap';

import { toast } from 'react-toastify'


import { Form, Col, Row } from 'react-bootstrap'

import { Formik } from 'formik';
import * as yup from 'yup';

import Dialog from '../../services/Dialogs'

import { tipoInversion } from '../../services/funcionesPublicas'

const ModalInversionEditar = ( params : any ) => {

  const user = AuthService.getCurrentUser()

  const { show, handleClose, inversion } = params




  const dialog = new Dialog();


  const mensajes_validacion_generico = "Este campo es obligatorio"
  const schema = yup.object().shape({
          monto_inversion : yup.number().required(mensajes_validacion_generico),
          forma_pago : yup.string().required(mensajes_validacion_generico),
          tasa_incremento : yup.number().required(mensajes_validacion_generico),
          plazo_contrato : yup.number().required(mensajes_validacion_generico),
          tipo_retiro : yup.string().required(mensajes_validacion_generico),
  });


  const [ envio_server, setSeEnvio ] = useState<boolean>(false)


  const enviarFormulario = async (registro:any,event:any) =>{
        await dialog.open({
          accept: 'Si',
          cancel: 'Espera',
          dialogClass: '',
          message: '¿Estás seguro de la información?',
          target: event.target,
          template: ''
        })
        let dialogo : any = await dialog.waitForUser()
        if(dialogo){
          try{

          setSeEnvio(true)
          let res_ = await RequestService.update( `inversion/actualizar_informacion/${inversion.uuid_inversion}` , { ...registro })

          if(res_){
            toast.success('Los datos de la inversión fueron actualizadas')
            setTimeout(()=>{
              handleClose()
            },0)
          }
          else{
            toast.error('Problemas...')
          } 
          }
          catch(e:any){
            toast.error(e.response.data)
            // console.log(e.response.data)
          } 
          
        }
       
  }




  return (
    <>
      <Modal show={show} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Cambiar Información de la Inversión</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {

          }

            <h4>Información de Cliente</h4>
            <table className="table table-sm">
              <tbody>
                <tr>
                  <th className="v" style={{width:'40%'}}>Nombre</th>
                  <td>
                    <b>{inversion.nombres}</b>
                    <p className="nm"><small>{`${inversion.paterno} ${inversion.materno}`}</small></p>
                    </td>
                </tr>
                <tr>
                  <th className="v">Fecha de Nacimiento</th>
                  <td>{inversion.fecha_nacimiento}</td>
                </tr>
                <tr>
                  <th className="v">Sexo</th>
                  <td>{inversion.sexo==='H'?'HOMBRE':'MUJER'}</td>
                </tr>
                <tr>
                  <th className="v">CURP</th>
                  <td>{inversion.curp}</td>
                </tr>
                <tr>
                  <th className="v">Seguro Social</th>
                  <td>{inversion.seguro_social}</td>
                </tr>
              </tbody>
            </table>






            <h4>Información de Inversión</h4>



            <Formik
              validationSchema={schema}
              onSubmit={(values,e)=>{enviarFormulario(values, e)}}
              initialValues={{
                    forma_pago : inversion.forma_pago,
                    monto_inversion : inversion.monto_inversion,
                    tasa_incremento : inversion.tasa_incremento,
                    plazo_contrato : inversion.plazo_contrato,
                    tipo_retiro : inversion.tipo_retiro,
              }}
            >
              {({
                handleSubmit,
                handleChange,
                setFieldValue,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
              }) => (
                <Form id='my-form' noValidate onSubmit={handleSubmit}>










                    <div className="row">
                      <div className="col-sm-6">
                            
                          <Form.Group className="mb-3" controlId="monto_inversion">
                            <Form.Label>Inversión</Form.Label>
                            <Form.Control
                              required
                              name="monto_inversion"
                              value={values.monto_inversion}
                              onChange={(e)=>{ setFieldValue('monto_inversion', e.target.value ) }}
                              isInvalid={!!errors.monto_inversion}
                            />
                            <Form.Control.Feedback type="invalid"> {<>{errors.monto_inversion}</>} </Form.Control.Feedback>
                          </Form.Group>


                      </div>
                      <div className="col-sm-6">
                        
                          <Form.Group className="mb-3" controlId="tasa_incremento">
                            <Form.Label>Tasa de Incremento (%)</Form.Label>
                            <Form.Control
                              required
                              name="tasa_incremento"
                              value={values.tasa_incremento}
                              onChange={(e)=>{ setFieldValue('tasa_incremento', e.target.value ) }}
                              isInvalid={!!errors.tasa_incremento}
                            />
                            <Form.Control.Feedback type="invalid"> {<>{errors.tasa_incremento}</>} </Form.Control.Feedback>
                          </Form.Group>
                          
                      </div>
                    </div>

              <div className="mb-3">
                <label className="form-label">Forma de Pago</label>
                  <Form.Select aria-label="Selección de Sucursal" required value={values.forma_pago} onChange={(e)=>{ setFieldValue('forma_pago',e.target.value) }} isInvalid={!!errors.forma_pago} >
                    <option>Selecciona una Forma</option>
                    <option value={'EFECTIVO'}>EFECTIVO</option>
                    <option value={'TRANSFERENCIA'}>TRANSFERENCIA</option>
                    <option value={'CHEQUE'}>CHEQUE</option>
                    <option value={'DEPÓSITO EFECTIVO'}>DEPÓSITO EFECTIVO</option>

                  </Form.Select>
                  <Form.Control.Feedback type="invalid"> {errors.forma_pago} </Form.Control.Feedback>
              </div>

                    <div className="row">
                      <div className="col-sm-5">
                      
                            <Form.Group className="mb-3" controlId="plazo_contrato">
                              <Form.Label>Plazo Contrato</Form.Label>
                              <Form.Select required  name="plazo_contrato"  value={values.plazo_contrato}  onChange={(e)=>{ setFieldValue('plazo_contrato', e.target.value ) }} isInvalid={!!errors.plazo_contrato}>
                                  <option value={6}>6 MESES</option>
                                  <option value={7}>7 MESES</option>
                                  <option value={8}>8 MESES</option>
                                  <option value={9}>9 MESES</option>
                                  <option value={10}>10 MESES</option>
                                  <option value={11}>11 MESES</option>
                                  <option value={12}>12 MESES</option>
                                  <option value={13}>13 MESES</option>
                                  <option value={14}>14 MESES</option>
                                  <option value={15}>15 MESES</option>
                                  <option value={16}>16 MESES</option>
                                  <option value={17}>17 MESES</option>
                                  <option value={18}>18 MESES</option>
                                  <option value={19}>19 MESES</option>
                                  <option value={20}>20 MESES</option>
                                  <option value={21}>21 MESES</option>
                                  <option value={22}>22 MESES</option>
                                  <option value={23}>23 MESES</option>
                                  <option value={24}>24 MESES</option>
                              </Form.Select> 
                              <Form.Control.Feedback type="invalid"> {<>{errors.plazo_contrato}</>} </Form.Control.Feedback>
                            </Form.Group>

                      </div>
                      <div className="col-sm-7">
                        
                          <Form.Group className="mb-3" controlId="tipo_retiro">
                            <Form.Label>Tipo de Retiro</Form.Label>
                            <Form.Select required  name="tipo_retiro"  value={values.tipo_retiro}  onChange={(e)=>{ setFieldValue('tipo_retiro', e.target.value ) }} isInvalid={!!errors.tipo_retiro}>
                              <option value="mensual">{tipoInversion('mensual')}</option>
                              <option value="finalizando">{tipoInversion('finalizando')}</option>
                            </Form.Select> 
                            <Form.Control.Feedback type="invalid"> {<>{errors.tipo_retiro}</>} </Form.Control.Feedback>
                          </Form.Group>
                          
                      </div>
                    </div>



                </Form>
              )}
            </Formik>









        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="success" form='my-form' type="submit">Guardar Cambios<i className="fa fa-save"/></Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}


export default ModalInversionEditar;